import { render, staticRenderFns } from "./MainContentAuth.vue?vue&type=template&id=71e2c544"
import script from "./MainContentAuth.vue?vue&type=script&lang=js"
export * from "./MainContentAuth.vue?vue&type=script&lang=js"
import style0 from "./MainContentAuth.vue?vue&type=style&index=0&id=71e2c544&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports